import { getViewportInfo, isClient } from '@tcp/core/src/utils';

export const renderDifferentImageOnMobile = (showDifferentImageOnMobile, showVideoOnMobile) => {
  const { isMobile } = getViewportInfo() || {};
  return isClient() && isMobile && showDifferentImageOnMobile && !showVideoOnMobile;
};

export const getDisableVideosOnAppleValue = (
  disableVideosForAppleDevice,
  disableVideosForAppleDeviceValue
) => disableVideosForAppleDevice || disableVideosForAppleDeviceValue;
